// Шаги перемотки: кнопки дока, хоткеи ←/→ и Media Session — одни и те же.
export const SKIP_BACK_SEC = 15
export const SKIP_FORWARD_SEC = 30

export const PLAYBACK_RATES = [0.8, 1, 1.2, 1.5, 1.75, 2] as const
